import { ACTIONS } from "../../_config";
import { ActionExtended } from "../../_config/interfaces/interfaces";
import { Dialog, Option } from "../../_config/types";

export interface MasterReducer {
    states: Option[] | null;
    allCounty: Option[] | null;
    allCity: Option[] | null;
    countries: Option[] | null;
    lookupValues: any;
    locations: any[] | null;
    currencyList: any[] | null;
    timezones: any[] | null;
    returnReasons: any[] | null;
}

const initialState: MasterReducer = {
    states: null,
    allCounty: null,
    allCity: null,
    countries: null,
    lookupValues: null,
    locations: null,
    currencyList: null,
    timezones: null,
    returnReasons: null,
};

const masterReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.MASTER.STATES:
            return { ...state, states: action.payload };
        case ACTIONS.MASTER.COUNTY:
            return { ...state, allCounty: action.payload };
        case ACTIONS.MASTER.CITY:
            return { ...state, allCity: action.payload };
        case ACTIONS.MASTER.COUNTRY:
            return { ...state, countries: action.payload };
        case ACTIONS.MASTER.LOOKUP_VALUES:
            return { ...state, lookupValues: action.payload };
        case ACTIONS.CATEGORIES.LOCATION_SEARCH:
            return { ...state, locations: action.payload };
        case ACTIONS.CATEGORIES.GET_CURRENCY:
            return { ...state, currencyList: action.payload };
        case ACTIONS.MASTER.TIMEZONES:
            return { ...state, timezones: action.payload };
        case ACTIONS.MASTER.RETURN_REASONS:
            return { ...state, returnReasons: action.payload };
        default:
            return state;
    }
};

export default masterReducer;
